module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat_L-8146.d8d3f869.png";